export const listPeople = [
    {
        "name": "ブース(個室)",
        "id": "0-5"
    },
    {
        "name": "~20人",
        "id": "6-20"
    },
    {
        "name": "21~40人",
        "id": "21-40"
    },
    {
        "name": "41~60人",
        "id": "41-60"
    },
    {
        "name": "61~100人",
        "id": "61-100"
    },
    {
        "name": "101人~",
        "id": "101-"
    }
];

export const filterQueryParams = (query) => {
    const cleanQuery = Object.entries(query).reduce((acc, [key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            acc[key] = value;
        }
        return acc;
    }, {});
    
    return cleanQuery;
}

export const getDateTime = (dateTime) => {
    const [selectedDate = '', timeRange = ''] = (dateTime || '').split(' ');
    const [timeStart = '', timeEnd = ''] = timeRange.split('～');

    return [
        selectedDate,
        timeStart,
        timeEnd,
    ];
};